import React from 'react';
import PropTypes from 'prop-types';

import classes from './Arrow.css';

const arrow = props => {
  const { direction } = props;
  let arrowElement;

  switch (direction) {
    case 'next':
      arrowElement = <span className={classes.Next}>&gt;</span>;
      break;
    case 'nextSideBarActive':
      arrowElement = <span className={classes.NextSideBarActive}>&gt;</span>;
      break;
    case 'nextSideBarInactive':
      arrowElement = <span className={classes.NextSideBarInactive}>&gt;</span>;
      break;
    case 'back':
      arrowElement = (
        <span className={classes.Back}>
          &lt;
          <br />
        </span>
      );
      break;
    default:
      arrowElement = <span className={classes.Next}>&gt;</span>;
  }

  return <div className={classes.Arrow}>{arrowElement}</div>;
};

arrow.propTypes = {
  direction: PropTypes.string
};

export default arrow;
